// extracted by mini-css-extract-plugin
export default {"item":"KWwYZP","label":"dAeAqs","value":"GEL2FC","valueList":"wYfmXv","valueItem":"J2Fuch","colorsHex":"brxM1i","colorsTitle":"XaFOTa"};